import React, { useEffect, useState } from 'react';
import { getMedias } from '../services/mediaService';

function MediaAlbum() {
  const [videos, setVideos] = useState([]);
  const [notas, setNotas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMedias = async () => {
      try {
        // Cargar videos de YouTube
        const videosData = await getMedias('videos');
        setVideos(videosData.slice(0, 3)); // Solo las primeras 3

        // Cargar notas periodísticas
        const notasData = await getMedias('notas_periodisticas');
        setNotas(notasData.slice(0, 3)); // Solo las primeras 3
      } catch (err) {
        console.error('Error al cargar medios:', err);
        setError('Error al cargar las apariciones en medios');
      } finally {
        setLoading(false);
      }
    };

    fetchMedias();
  }, []);

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando apariciones...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container py-5">
        <div className="alert alert-danger">{error}</div>
      </div>
    );
  }

  return (
    <main>
      <div id="media" className="album py-5">
        <div className="container">
          
          {/* SECCIÓN 1: Videos Youtube y X*/}
          {videos.length > 0 && (
            <>
              <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 mb-5">
                {videos.map((item) => (
                  <div className="col" key={item.id}>
                    <div className="card shadow-sm h-100">
                      <div className="ratio ratio-16x9">
                        <iframe
                          src={item.url_embed}
                          title={item.titulo}
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>

                     <div className="card-body d-flex flex-column">
                      <h5 className="card-title">{item.titulo}</h5>
                        {item.bajada && (
                          <p className="card-text flex-grow-1">{item.bajada}</p>
                        )}
  
                        <div className="d-flex justify-content-between align-items-center mt-auto">
                          {item.medio && (
                            <small className="text-muted">{item.medio}</small>
                          )}
                          {item.fecha_publicacion && (
                            <small className="text-muted">
                              {new Date(item.fecha_publicacion).toLocaleDateString()}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {/* SECCIÓN 2: Notas Periodísticas */}
          {notas.length > 0 && (
            <>      
              <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
                {notas.map((item) => (
                  <div className="col" key={item.id}>
                    <div className="card shadow-sm h-100">
                      {/* Card sin imagen, solo contenido */}
                      <div className="card-body d-flex flex-column">
                        {item.medio && (
                          <div className="mb-2 pb-2">
                            <span className="badge-custom">{item.medio}</span>
                          </div>
                        )}
                        <h5 className="card-title pb-2">{item.titulo}</h5>
                        {item.bajada && (
                          <p className="card-text text-muted flex-grow-1">
                            {item.bajada.length > 200 
                              ? `${item.bajada.substring(0, 200)}...` 
                              : item.bajada
                            }
                          </p>
                        )}
                        <div className="d-flex justify-content-between align-items-center mt-1">
                          <div className="btn-group">
                            <a
                              href={item.link_externo}
                              className="btn btn-sm btn-outline-secondary"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Ir a la nota
                            </a>
                          </div>
                          {item.fecha_publicacion && (
                            <small className="text-muted">
                               {new Date(item.fecha_publicacion).toLocaleDateString()}
                            </small>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {/* Mensaje si no hay contenido */}
          {videos.length === 0 && notas.length === 0 && (
            <div className="alert alert-info text-center">
              No hay apariciones en medios disponibles en este momento.
            </div>
          )}
        </div>
      </div>
    </main>
  );
}

export default MediaAlbum;